import {
  Box,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField
} from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";
import { EditMode, RenewalType } from "../../../models";
import { PlanFormValues } from "../PlanFormValues";

type GiftingSettingsFieldsProps = {
  isPilot: boolean;
  editMode: EditMode;
};

export const GiftingSettingsFields: React.FC<GiftingSettingsFieldsProps> = ({
  isPilot,
  editMode
}) => {
  const { values, errors, touched, handleChange, setFieldValue } =
    useFormikContext<PlanFormValues>();

  const handlePeriodChange = (newPeriod: number) => {
    if (newPeriod === -1) {
      setFieldValue("renewalOptions.type", RenewalType.NEVER);
      setFieldValue("renewalOptions.periodInMonths", null);
    } else {
      setFieldValue("renewalOptions.type", RenewalType.INDIVIDUAL_START_DATE);
      setFieldValue("renewalOptions.periodInMonths", newPeriod);
    }
  };

  return (
    <>
      <Box>
        <FormControl component="fieldset" fullWidth>
          <FormLabel component="legend">Gift Name</FormLabel>
          <TextField
            name="name"
            value={values.name}
            onChange={handleChange}
            required
            fullWidth
            size="small"
            error={touched.name && Boolean(errors.name)}
            helperText={touched.name && (errors.name as string)}
          />
        </FormControl>
      </Box>
      <Box>
        <FormControl fullWidth>
          <FormLabel>When should this Gift expire?</FormLabel>
          <Select
            name="renewalOptions.periodInMonths"
            value={values.renewalOptions.periodInMonths ?? -1}
            onChange={(e: SelectChangeEvent<number>) =>
              handlePeriodChange(+e.target.value)
            }
            disabled={editMode === EditMode.EDIT || isPilot}
          >
            <MenuItem value={-1}>Never</MenuItem>
            <MenuItem value={1}>In 1 month</MenuItem>
            <MenuItem value={2}>In 2 months</MenuItem>
            <MenuItem value={3}>In 3 months</MenuItem>
            <MenuItem value={6}>In 6 months</MenuItem>
            <MenuItem value={12}>In 1 year</MenuItem>
            <MenuItem value={24}>In 2 years</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </>
  );
};
